(function () {
    var bound = false;

    function getSrvData() { var data = window.sharkSrvProductData ? window.sharkSrvProductData() : null; return data && data.product ? data : null; }

    function buildMetaIndex() {
        var data = getSrvData();
        if (data && data.v10ViewModel && data.v10ViewModel.metaIndex) {
            window.SHARK_ITEM_META = data.v10ViewModel.metaIndex;
            return window.SHARK_ITEM_META;
        }
        var rows = (data && data.itemMeta) || [];
        var index = {};
        rows.forEach(function (row) {
            var scope = row.meta_scope;
            if (!index[scope]) index[scope] = {};
            try { index[scope][row.meta_key] = JSON.parse(row.meta_json); } catch (e) {}
        });
        window.SHARK_ITEM_META = index;
        return index;
    }

    var expandedMode = window.matchMedia('(min-width:992px)');
    var mobileMode = window.matchMedia('(max-width:767px)');
    var appliedMode = '';

    function closeAccordion(item) {
        if (!item) return;
        item.classList.remove('open');
        var trigger = item.querySelector('.mobile-section-launcher');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        var panel = item.querySelector('.mobile-accordion-panel');
        if (panel) { panel.setAttribute('aria-hidden', 'true'); panel.inert = true; }
    }

    function openAccordion(item) {
        if (!item) return;
        item.classList.add('open');
        var trigger = item.querySelector('.mobile-section-launcher');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var panel = item.querySelector('.mobile-accordion-panel');
        if (panel) { panel.setAttribute('aria-hidden', 'false'); panel.inert = false; }
    }

    function currentMode() {
        return expandedMode.matches ? 'expanded' : mobileMode.matches ? 'mobile' : 'compact';
    }

    function syncAccordionDefaults() {
        var next = currentMode();
        if (next === appliedMode) return;
        appliedMode = next;
        var items = Array.prototype.slice.call(document.querySelectorAll('.product-accordion-list>.mobile-accordion-item'));
        items.forEach(openAccordion);
    }

    var pinnedSignature = null;

    function closeSignaturePopovers(except) {
        document.querySelectorAll('.build-signature').forEach(function (signature) {
            if (signature === except) return;
            signature.classList.remove('is-open');
            signature.setAttribute('aria-expanded', 'false');
        });
        if (pinnedSignature !== except) pinnedSignature = null;
    }

    function showSignature(signature) {
        if (!signature) return;
        closeSignaturePopovers(signature);
        signature.classList.add('is-open');
        signature.setAttribute('aria-expanded', 'true');
    }

    var titleFitFrame = 0;
    var lastFitWidth = -1;

    function fitModelTitle() {
        var titleElement = document.querySelector('.item-v10 .item-title');
        var titleContainer = document.querySelector('.item-v10 .pd-info');
        var signatureGroup = document.querySelector('.item-v10 .build-signatures');
        if (!titleElement || !titleContainer) return;
        titleElement.style.removeProperty('font-size');
        if (window.matchMedia('(min-width:992px)').matches && signatureGroup) {
            var titleBox = titleElement.getBoundingClientRect();
            var signatureBox = signatureGroup.getBoundingClientRect();
            var available = Math.max(220, signatureBox.left - titleBox.left - 16);
            titleElement.style.maxWidth = available + 'px';
        } else {
            titleElement.style.removeProperty('max-width');
        }
        if (titleElement.scrollWidth <= titleElement.clientWidth + 1) return;
        var high = parseFloat(getComputedStyle(titleElement).fontSize) || 40;
        var minSize = parseFloat(getComputedStyle(titleElement).getPropertyValue('--item-title-min')) || 22;
        var low = Math.min(minSize, high);
        for (var step = 0; step < 8; step++) {
            var mid = (low + high) / 2;
            titleElement.style.setProperty('font-size', mid + 'px');
            if (titleElement.scrollWidth <= titleElement.clientWidth + 1) low = mid; else high = mid;
        }
        titleElement.style.setProperty('font-size', Math.max(minSize, low) + 'px');
    }

    function scheduleTitleFit() {
        if (titleFitFrame) return;
        titleFitFrame = requestAnimationFrame(function () {
            titleFitFrame = 0;
            fitModelTitle();
        });
    }

    function handleDocumentClick(event) {
        var signature = event.target.closest('.build-signature');
        if (signature) {
            var shouldPin = pinnedSignature !== signature;
            pinnedSignature = null;
            closeSignaturePopovers();
            if (shouldPin) {
                pinnedSignature = signature;
                showSignature(signature);
            }
            return;
        }
        pinnedSignature = null;
        closeSignaturePopovers();
        var hintClose = event.target.closest('[data-designer-hint-close]');
        if (hintClose) {
            var hint = hintClose.closest('[data-designer-hint]');
            if (hint) hint.hidden = true;
            return;
        }
        var accordionTrigger = event.target.closest('.mobile-section-launcher');
        if (accordionTrigger) {
            var item = accordionTrigger.closest('.mobile-accordion-item');
            if (item.classList.contains('open')) closeAccordion(item); else openAccordion(item);
        }
    }

    function bindStatic() {
        if (bound) return;
        var root = document.querySelector('.item-v10');
        if (!root) return;
        bound = true;
        document.addEventListener('click', handleDocumentClick);
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                pinnedSignature = null;
                closeSignaturePopovers();
            }
        });
        ['pointerover', 'focusin'].forEach(function (type) {
            document.addEventListener(type, function (event) {
                var signature = event.target.closest('.build-signature');
                if (signature && !pinnedSignature) showSignature(signature);
            });
        });
        document.addEventListener('pointerout', function (event) {
            var signature = event.target.closest('.build-signature');
            if (signature && !pinnedSignature && !signature.contains(event.relatedTarget)) closeSignaturePopovers();
        });
        expandedMode.addEventListener('change', syncAccordionDefaults);
        mobileMode.addEventListener('change', syncAccordionDefaults);
        syncAccordionDefaults();
        scheduleTitleFit();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleTitleFit);
        var titleContainer = document.querySelector('.item-v10 .pd-info');
        if ('ResizeObserver' in window && titleContainer) {
            new ResizeObserver(function (entries) {
                var width = entries[0] && entries[0].contentRect ? Math.round(entries[0].contentRect.width) : titleContainer.clientWidth;
                if (width === lastFitWidth) return;
                lastFitWidth = width;
                scheduleTitleFit();
            }).observe(titleContainer);
        }
        var productFaq = document.getElementById('product-faq');
        if (productFaq) {
            productFaq.querySelectorAll('details').forEach(function (item) {
                item.addEventListener('toggle', function () {
                    if (!item.open) return;
                    productFaq.querySelectorAll('details[open]').forEach(function (openItem) {
                        if (openItem !== item) openItem.open = false;
                    });
                });
            });
        }
    }

    window.initItemV10Page = function () {
        bindStatic();
        buildMetaIndex();
        if (typeof window.initItemV10QuickConfig === 'function') window.initItemV10QuickConfig();
        if (typeof window.initItemV10Specs === 'function') window.initItemV10Specs();
        scheduleTitleFit();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindStatic);
    } else {
        bindStatic();
    }
})();
